<template>
  <div class="">
    <slide-over-panel v-if="reminder !== null"
                v-model:show="$data._show"
                @update:show="updateShow($data._show)">
      <template #title>
        <div class="flex items-center">
          <span class="text-lg text-gray-900 text-left font-semibold">{{reminderProp.display_name}}</span>
        </div>
      </template>

      <template #content>
        <div class="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
            <!-- Alarm Notification delay -->
            <div>
              <label class="px-4 block text-sm font-medium text-gray-700" for="notification-delay">Alarm Notification Delay</label>
              <div class="mt-1 relative">
                <input
                    id="notification-delay"
                    v-model="delayTime"
                    :class="[! canEditEscalation ? 'cursor-not-allowed' : '']"
                    :disabled="! canEditEscalation"
                    class="py-3 px-4 block w-full shadow-lg focus:ring-indigo-500 focus:border-indigo-500 ring-black border-gray-100 rounded-md border-2"
                    name="notification-delay"
                    @keypress="isNumber($event)"/>
                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 sm:text-sm"> Minutes </span>
                </div>
              </div>
            </div>

            <!-- Re-notification interval -->
            <div>
              <label class="px-4 block text-sm font-medium text-gray-700" for="renotification-interval">Re-notification Interval</label>
              <div class="col-span-2 mt-1 relative">
                <input
                    id="renotification-interval"
                    v-model="renotificationTime"
                    :class="[! canEditEscalation ? 'cursor-not-allowed' : '']"
                    :disabled="! canEditEscalation"
                    class="py-3 px-4 block w-full shadow-lg focus:ring-indigo-500 focus:border-indigo-500 ring-black border-gray-100 rounded-md border-2"
                    name="renotification-interval"
                    @keypress="isNumber($event)"/>
                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 sm:text-sm"> Minutes </span>
                </div>
              </div>
            </div>

            <!-- Unsnooze Notifications -->
            <div    v-if="unSnoozeNotificationEnabled"
                    class="col-span-1 sm:col-span-2">
                <h5>Un-snooze Notifications</h5>
                <p  class="text-sm leading-5 text-gray-600">
                    These Notifications will be sent when an alarm you are setup to receive notifications for is unsnoozed.
                </p>
                <unsnooze-notification-radio
                    v-model:unsnoozeNotificationSetting="unsnoozeNotificationSetting"></unsnooze-notification-radio>
            </div>
        </div>

        <div    v-if="canEditEscalation"
                class="py-3">
          <green-button @click="save"
          >
            <div v-if="processing"
                 class="inline-flex">
              <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
              <span class="pl-4">Processing</span>
            </div>
            <div v-else
                 class="inline-flex">
              <span>Save Changes</span>
            </div>
          </green-button>
        </div>


      </template>
    </slide-over-panel>

    <!--    Notification modal for the results -->
    <notification-modal
        v-model:is-open="showResultModal"
    >
      <template #title-content>
        Update Successful!
      </template>
      {{ modalText }}
    </notification-modal>

  </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SlideOverPanel from '@/components/elements/SlideOverPanel';
import GreenButton from '@/components/elements/green-button';
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import Select2 from '@/components/elements/select2';
import ButtonRedPrimary from "@/components/elements/buttons/ButtonRedPrimary";
import ButtonAjax from "@/components/elements/buttonAjax";
import NotificationModal from "@/components/elements/NotificationModal";
import SonicuButton from "@/components/elements/buttons/SonicuButton";
import UnsnoozeNotificationRadio from "./Users/UnsnoozeNotificationRadio.vue";

export default {
  name: "AlarmReminderEdit",
  mixins: [SonicuCoreMixin, iconNamesMixin],
  components: {
      UnsnoozeNotificationRadio,
    SonicuButton,
    NotificationModal, ButtonAjax, ButtonRedPrimary, SmallColoredCheck, SlideOverPanel, GreenButton},
  props: {
    reminderProp: Object,
    show: Boolean,
    unSnoozeNotificationEnabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      _show: this.show,
      usersToSubmit: {},
      reminder: {},
      processing: false,
      showResultModal: false,
      showConfirmModal: false,
      modalText: '',
      userToUpdate: null,
      delayTime: null,
      renotificationTime: null,
      unsnoozeNotificationSetting: 'do_not_notify',
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    updateShow(show) {
      this.$data._show = show
      this.$emit('update:show', this.$data._show)
    },
    save() {
      this.processing = true;
      axios.post(this.company.buildCompanyApiInternalRoute('alarm-reminders'),
          {
            users_to_update: [{
                'id': this.reminderProp.id,
                'pivot': {
                  'delay_time': this.delayTime,
                  'renotification_time': this.renotificationTime,
                  'notify_on_unsnooze': this.unsnoozeNotificationSetting,
                }
            }]
          }
      ).then(response => {
        this.modalText = "User Settings Updated!";
        this.showResultModal = true;
        this.userToUpdate = null;
        this.processing = false;
        this.reminderProp.pivot.renotification_time = this.renotificationTime;
        this.reminderProp.pivot.delay_time = this.delayTime;
        this.reminderProp.pivot.notify_on_unsnooze = this.unsnoozeNotificationSetting;
      }).catch(error => {
        console.log(error)
        this.processing = false;
      })
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updateValuesToUpdate(event) {
      this.userToUpdate = event;
    },

  },
  computed: {
    canEditEscalation() {
      return this.permissions.can('edit_alarm_reminder');
    }
  },
  watch: {
    show() {
      console.log(this.show);
      this.$data._show = this.show;
    },
    reminderProp: function (newVal, oldVal) {
      this.delayTime = newVal.pivot.delay_time;
      this.renotificationTime = newVal.pivot.renotification_time;
      this.unsnoozeNotificationSetting = newVal.pivot.notify_on_unsnooze;
      this.reminder = _.clone(newVal);
    },
    showResultModal: function(newVal, oldVal) {
      console.log('showing result update');
      if(newVal === false){
        this.updateShow(false);
      }
    }
  },
}

</script>

<style scoped>

</style>